import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Fett } from './CodeFelder';
import { APP_SYMBOL, STORE, STORE_QR_SATZ, GUT_ZU_WISSEN, appSchritte } from '../../lib/zweiFaktor';

export const ReiterWahl = ({ reiter, onWahl }) => (
  <div className="inline-flex rounded-lg bg-slate-100 p-1" role="tablist" aria-label="Handy-Art">
    {[['android', 'Android'], ['iphone', 'iPhone']].map(([wert, name]) => (
      <button
        key={wert}
        type="button"
        role="tab"
        aria-selected={reiter === wert}
        onClick={() => onWahl(wert)}
        className={`rounded-md px-4 py-1.5 text-sm font-medium transition-colors ${reiter === wert ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'}`}
        data-testid={`zwei-faktor-reiter-${wert}`}
      >
        {name}
      </button>
    ))}
  </div>
);

export const AppKarte = ({ reiter, art }) => {
  const store = STORE[reiter];
  return (
    <div className="space-y-3 rounded-lg border p-3" data-testid="zwei-faktor-app-karte">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex min-w-0 flex-1 basis-48 items-center gap-3">
          <img src={APP_SYMBOL} alt="" className="h-12 w-12 shrink-0 rounded-xl" data-testid="zwei-faktor-app-symbol" />
          <div className="min-w-0">
            <p className="font-semibold text-slate-900" data-testid="zwei-faktor-app-name">Google Authenticator</p>
            <p className="text-xs text-slate-500" data-testid="zwei-faktor-app-untertitel">von Google LLC · kostenlos</p>
          </div>
        </div>
        <Button asChild className="shrink-0 whitespace-nowrap bg-blue-800 hover:bg-blue-900">
          <a href={store.url} target="_blank" rel="noopener noreferrer" data-testid="zwei-faktor-store-knopf">
            <ExternalLink className="mr-2 h-4 w-4" />
            {store.knopf}
          </a>
        </Button>
      </div>
      {art === 'pc' && (
        <>
          <div className="flex items-center gap-2 text-xs text-slate-400">
            <div className="h-px flex-1 bg-slate-200" />
            oder am PC
            <div className="h-px flex-1 bg-slate-200" />
          </div>
          <div className="flex items-center gap-3">
            <img src={store.qr} alt={`QR-Code zum ${store.name}`} className="h-[120px] w-[120px] shrink-0 bg-white" data-testid="zwei-faktor-store-qr" />
            <p className="text-sm text-slate-600">{STORE_QR_SATZ}</p>
          </div>
        </>
      )}
    </div>
  );
};

export const NummernListe = ({ punkte, testid }) => (
  <ol className="list-decimal space-y-1.5 pl-5 text-sm text-slate-700" data-testid={testid}>
    {punkte.map((p) => <li key={p}><Fett text={p} /></li>)}
  </ol>
);

export const GutZuWissen = () => (
  <details className="rounded-lg border bg-slate-50 p-3 text-sm" data-testid="zwei-faktor-gut-zu-wissen">
    <summary className="cursor-pointer font-medium text-slate-800">Gut zu wissen</summary>
    <ul className="mt-2 list-disc space-y-1.5 pl-5 text-slate-700">
      {GUT_ZU_WISSEN.map((p) => <li key={p}><Fett text={p} /></li>)}
    </ul>
  </details>
);

export const AppAnleitung = ({ art, onSchonDa }) => {
  const [reiter, setReiter] = useState(art === 'iphone' ? 'iphone' : 'android');
  return (
    <div className="space-y-4" data-testid="zwei-faktor-app-anleitung">
      <ReiterWahl reiter={reiter} onWahl={setReiter} />
      <AppKarte reiter={reiter} art={art} />
      <NummernListe punkte={appSchritte(reiter, art)} testid="zwei-faktor-app-schritte" />
      <Button type="button" variant="outline" onClick={onSchonDa} data-testid="zwei-faktor-app-schon-da">
        Ich habe die App schon
      </Button>
      <GutZuWissen />
    </div>
  );
};

export default AppAnleitung;
